import React, { useEffect, useState } from 'react';
import { UserRelationRoleEnum } from '../../api/types';
import { Api } from '../../api';
import { DossierMember } from '../../models/DossierMember';
import Spinner from 'react-bootstrap/Spinner';

interface ICaregiversListProps {
  dossierId: number;
}

export function CaregiversList({ dossierId }: ICaregiversListProps): JSX.Element {
  const [caregivers, setCaregivers] = useState<DossierMember[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    Api.listDossierRelations(dossierId)
      .then(relations => {
        setCaregivers(relations.filter(relation => relation.role === UserRelationRoleEnum.caregiver));
      })
      .catch(err => {
        console.error('Failed to load dossier relations', err);
        setCaregivers([]);
      })
      .finally(() => setLoading(false));
  }, [dossierId]);

  return (
    <>
      {
        caregivers.map((caregiver: DossierMember, index: number) => (
          <span key={caregiver.memberId}>
            {caregiver.user.name}
            {caregivers[index + 1] ? ', ' : ''}
          </span>
        ))
      }
      { loading && <Spinner variant="primary" animation="border" /> }
    </>
  );
}
